module.exports = __webpack_public_path__ + "img/1397541274.5f9a2271.jpg";